import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getSetInitialPasswordPath = (userId: string = ':userId', token: string = ':token') => {
  return urlHelper(`/users/${userId}/set-initial-password/${token}/`);
};
